import { gql } from "@apollo/client";

export const GET_ACTIVE_USERS = gql `
query GetUsersToAddTickets ($pageSize: Int, $pageOffset: Int, $order_by: [user_order_by], $searchText: String = "%") {
  user(where: {_or:[{u_email_id:{_ilike:$searchText}},{u_full_name:{_ilike:$searchText}}],u_deleted_at:{_is_null:true},u_role:{_eq:"user"},u_is_active:{_eq:true}}, offset: $pageOffset, limit: $pageSize, order_by: $order_by) {
    u_id
    u_email_id
    u_first_name
    u_last_name
    u_full_name
    u_created_at
    u_updated_at
  }
  user_aggregate(where: {_or:[{u_email_id:{_ilike:$searchText}},{u_full_name:{_ilike:$searchText}}],u_deleted_at:{_is_null:true},u_role:{_eq:"user"},u_is_active:{_eq:true}}) {
    aggregate {
      count
    }
  }
}
`;

export const GET_LEAGUES = gql `query GetLeaguesWithType {
  leagues(where: {l_is_active: {_eq: true}, l_deleted_at: {_is_null: true}}, order_by: {l_order: asc}) {
    l_id
    l_name
    l_is_active
    l_created_at
    l_updated_at
    l_order
    l_type
  }
}
`;

export const GET_ALL_VENUES_BY_LEAGUEID = gql `
query GetAllVenueOfTeamWithRefIdBylIdAndSearchName($l_id: uuid!, $limit: Int, $offset: Int, $search_string: String = "%") {
  league_team_venues(distinct_on: [ltv_name], where: {_and: [{_or: [{all_venue: {av_name: {_ilike: $search_string}}}, {ltv_name: {_ilike: $search_string}}]}, {league_team: {l_id: {_eq: $l_id}}}, {league_team: {league: {l_type: {_neq: Sports}}}}]}, order_by: {ltv_name: asc}, limit: $limit, offset: $offset) {
    ltv_name
    ltv_id
    ltv_is_active
    ltv_updated_at
    all_venue {
      av_id
      av_name
      av_street
      av_city
      av_country_code
      av_zipcode
      av_timezone
      av_state_code
      av_venue_ref_id
      av_latitude
      av_longitude
    }
  }
}
`

export const GET_LEAGUE_CATEGORIES_BY_LEAGUE_ID = gql `query GetLeagueCategoriesByLeagueIdToAddTicket ($l_id: uuid, $limit: Int, $offset: Int, $lcName: String = "%") {
  league_categories(where: {_and:[{l_id:{_eq:$l_id}},{lc_deleted_at:{_is_null:true}},{lc_name:{_ilike:$lcName}}, { lc_ticketmaster_name: { _is_null: false } }]}, offset: $offset, limit: $limit) {
    lc_id
    lc_name
    lc_brand_name
    lc_market_name
  }
}`;

export const GET_EVENTS_BY_HOME_AND_AWAY_TEAM_ID = gql `
  query GetEventsByTeamId (
  $homeTeamId: uuid!
  $awayTeamId: uuid!
  $limit: Int = 10
  $offset: Int = 0
  $orderBy: [events_order_by!]
  $activeFilter: [Boolean!] = [true]
) {
  events(
    where: {
      _and: [
        { event_categories: { ec_is_home: { _eq: true }, lc_id: { _eq: $homeTeamId } } },
        { event_categories: { ec_is_home: { _eq: false }, lc_id: { _eq: $awayTeamId } } },
        { e_platform_name: { _eq: "ticketmaster" }},
        { e_status: { _nin: ["closed", "postponed", "cancelled", "canceled", "unnecessary"] } },
        { e_is_active: { _in: $activeFilter } },
        {
          _or: [
            { e_date: { _gte: "now()" } },
            {
              _and: [
                { e_date: { _is_null: true } },
                { e_status: { _eq: "date-tbd" } }
              ]
            }
          ]
        },
        { e_deleted_at: { _is_null: true } }
      ]
    },
    order_by: $orderBy,
    limit: $limit,
    offset: $offset
  ) {
    e_id
    e_name
    e_date
    e_address
    e_status
    e_is_active
    e_state
    e_city
    e_stadium_name
    e_country
    e_game_id
    e_cdt_date
    e_cdt_date_with_year
  }

  events_aggregate(
    where: {
      _and: [
        { event_categories: { ec_is_home: { _eq: true }, lc_id: { _eq: $homeTeamId } } },
        { event_categories: { ec_is_home: { _eq: false }, lc_id: { _eq: $awayTeamId } } },
        { e_platform_name: { _eq: "ticketmaster" }},
        { e_status: { _nin: ["closed", "postponed", "cancelled", "canceled", "unnecessary"] } },
        { e_is_active: { _in: $activeFilter } },
        {
          _or: [
            { e_date: { _gte: "now()" } },
            {
              _and: [
                { e_date: { _is_null: true } },
                { e_status: { _eq: "date-tbd" } }
              ]
            }
          ]
        },
        { e_deleted_at: { _is_null: true } }
      ]
    },
    order_by: $orderBy
  ) {
    aggregate {
      count
    }
  }
}
`;

export const UPDATE_ACTIVE_OR_INACTIVE_EVENT = gql `
  mutation updateEventByEId($eId: uuid!, $setInput: events_set_input!) {
  update_events_by_pk(pk_columns: {e_id: $eId}, _set: $setInput) {
    e_id
  }
}
`;

export const GET_EVENTS_BY_HOME_TEAM_ID = gql `
  query GetEventsForBulkListByHomeTeamId ($homeTeamId: uuid!, $limit: Int = 10, $offset: Int = 0, $orderBy: [events_order_by!], $activeFilter: [Boolean!] = [true]) {
    events(where: {_and:[{event_categories:{ec_is_home:{_eq:true},lc_id:{_eq:$homeTeamId}}},{ e_platform_name: { _eq: "ticketmaster" }},{e_status:{_nin:["closed", "postponed", "cancelled", "canceled", "unnecessary"]}},{e_is_active:{_in:$activeFilter}},{e_date: {_gte: "now()"}}]}, order_by: $orderBy, limit: $limit, offset: $offset) {
      e_id
      e_name
      e_date
      e_address
      e_status
      e_is_active
      e_state
      e_city
      e_stadium_name
      e_country
      e_game_id
      e_cdt_date
      e_cdt_date_with_year
  }
  events_aggregate(where: {_and:[{event_categories:{ec_is_home:{_eq:true},lc_id:{_eq:$homeTeamId}}},{ e_platform_name: { _eq: "ticketmaster" }},{e_status:{_nin:["closed", "postponed", "cancelled", "canceled", "unnecessary"]}},{e_is_active:{_in:$activeFilter}},{e_date: {_gte: "now()"}}]}, order_by: {e_date:asc}) {
    aggregate {
      count
    }
  }
}
`;

export const GET_EVENT_BY_ID = gql `
  query GetEventById ($eventId: uuid!) {
    events(where: {e_id: {_eq: $eventId}}) {
      e_id
      e_name
      e_date
      e_address
      e_status
      e_state
      e_city
      e_stadium_name
      e_country
      e_game_id
      e_cdt_date
      e_cdt_date_with_year
  }
}
`;

export const GET_EVENT_BY_IDs = gql `
  query GetEventById ($eventId: [uuid!]!) {
    events(where: {e_id: {_in: $eventId}}, order_by: {e_date: asc}) {
      e_id
      e_name
      e_date
      e_address
      e_status
      e_state
      e_city
      e_stadium_name
      e_country
      e_game_id
      e_cdt_date
      e_cdt_date_with_year
  }
}
`;

export const ADD_TICKETS_BY_ADMIN = gql `
  mutation addTicketsByAdmin ($addTicketsByAdmin: AddTicketsByAdminInput!) {
    addTicketsByAdmin(addTicketsByAdminInput: $addTicketsByAdmin) {
      message
    }
  }
`;

export const VERIFY_TICKET_IN_LOGITIX = gql `
  mutation verifyTicketInLogitix ($verifyTicketInLogitixInput: VerifyTicketInLogitixInput!) {
    verifyTicketInLogitix(verifyTicketInLogitixInput: $verifyTicketInLogitixInput) {
      valid
      message
      error
      availableSections
      availableRows
      availableSeats
      availableSectionsHierarchy {
        section
        rows {
          row
          seats
        }
      }
    }
  }
`;

export const GET_EVENT_OTHER_LEAGUES = gql `query GetLeagueEventsByLeagueAndNameDistinctOnEname(
  $l_id: uuid,
  $limit: Int,
  $offset: Int,
  $search_string: String = "%",
  $activeFilter: [Boolean!] = [true]
) {
  events(
    distinct_on: e_name
    order_by: { e_name: asc }
    limit: $limit
    offset: $offset
    where: {
      _and: [
        { e_name: { _ilike: $search_string } },
        { e_deleted_at: { _is_null: true } },
        { e_status: { _nin: ["closed", "postponed", "cancelled", "canceled", "unnecessary"] } },
        { e_is_active: { _in: $activeFilter } },
        { event_categories: { league_category: { l_id: { _eq: $l_id } } } }
      ]
    }
  ) {
    e_id
    e_name
    e_brand_name
    e_date
    e_date_time_zone
    e_state
    e_status
    e_time_zone
    e_is_active

    event_categories {
      league_category {
        l_id
      }
    }
  }
}
`;


export const GET_EVENTS_BY_OTHER_LEAGUES = gql `
  query GetEventsofLeagueByEname($eventName: String = "%", $leagueId: uuid!, $limit: Int = 10, $offset: Int = 0, $orderBy: [events_order_by!], $activeFilter: [Boolean!] = [true]) {
  events(where: {_and: [{e_status: {_nin: ["closed", "postponed", "cancelled", "canceled", "unnecessary"]}, e_is_active: {_in: $activeFilter}, e_date: {_gte: "now()"}, e_name: {_ilike: $eventName}, event_categories: {league_category: {l_id: {_eq: $leagueId}}}}]}, order_by: $orderBy, limit: $limit, offset: $offset) {
    e_id
    e_name
    e_date
    e_address
    e_status
    e_is_active
    e_state
    e_city
    e_stadium_name
    e_country
    e_game_id
    e_cdt_date
    e_cdt_date_with_year
  }
  events_aggregate(where: {_and: [{e_status: {_nin: ["closed", "postponed", "cancelled", "canceled", "unnecessary"]}, e_is_active: {_in: $activeFilter}, e_date: {_gte: "now()"}, e_name: {_ilike: $eventName}, event_categories: {league_category: {l_id: {_eq: $leagueId}}}}]}, order_by: $orderBy) {
    aggregate {
      count
    }
  }
}`;

export const GET_LEAGUE_TEAMS_BY_LEAGUE_ID = gql `query GetAllTeamsOfLeague($l_id:uuid!, $limit:Int, $offset:Int) {
  league_teams(where: {l_id: {_eq: $l_id}}, order_by: {lt_name: asc}, limit: $limit, offset: $offset) {
    lt_id
    lt_abbreviation
    lt_alternative_names
    lt_brand_name
    lt_color_code
    lt_is_active
    lt_market_name
    lt_name
    lt_url
  }
}`;

export const GET_ALL_VENUE_OF_TEAM_BY_TEAM_ID = gql `query GetAllVenueOfTeamWithRefId($lt_id: uuid!, $limit: Int, $offset: Int) {
  league_team_venues(where: {lt_id: {_eq: $lt_id}}, order_by: {ltv_name: asc}, limit: $limit, offset: $offset) {
    ltv_name
    ltv_id
    ltv_is_active
    ltv_updated_at
    all_venue {
      av_id
      av_name
      av_street
      av_city
      av_country_code
      av_zipcode
      av_timezone
      av_state_code
      av_venue_ref_id
      av_latitude
      av_longitude
    }
  }
  league_team_venues_aggregate(where: {lt_id: {_eq: $lt_id}}) {
    aggregate {
      count
    }
  }
}`;
export const GET_ALL_VENUE_OF_TEAM_BY_LEAGUE_ID = gql `query GetAllVenueOfTeamWithRefIdBylIdandSearch($l_id: uuid!, $searchText: String = "%", $limit: Int, $offset: Int) {
  league_team_venues(where: {_and: [{_or: [{ltv_name: {_ilike: $searchText}}, {all_venue: {av_name: {_ilike: $searchText}}}]}, {league_team: {l_id: {_eq: $l_id}}}, {league_team: {league: {l_type: {_neq: Sports}}}}]}, order_by: {ltv_name: asc}, limit: $limit, offset: $offset) {
    ltv_name
    ltv_id
    ltv_is_active
    ltv_updated_at
    all_venue {
      av_id
      av_name
      av_street
      av_city
      av_country_code
      av_zipcode
      av_timezone
      av_state_code
      av_venue_ref_id
      av_latitude
      av_longitude
    }
  }
  league_team_venues_aggregate(where: {_and: [{_or: [{ltv_name: {_ilike: $searchText}}, {all_venue: {av_name: {_ilike: $searchText}}}]}, {league_team: {l_id: {_eq: $l_id}}}, {league_team: {league: {l_type: {_neq: Sports}}}}]}) {
    aggregate {
      count
    }
  }
  total_venues_of_league: league_team_venues_aggregate(
    where: {
      _and: [
        { league_team: { l_id: { _eq: $l_id } } }
        { league_team: { league: { l_type: { _neq: Sports } } } }
      ]
    }
  ) {
    aggregate {
      count
    }
  }
}`;

export const ADDING_NEW_VENUE_INTO_A_TEAM = gql `mutation AddNewVenueIntoTeamWithavId($lt_id: uuid!, $venue_name: String!, $av_id: uuid!) {
  insert_league_team_venues_one(object: {lt_id: $lt_id, ltv_name: $venue_name, av_id: $av_id}) {
    ltv_id
    ltv_name
  }
}
`;

export const ADDING_MULTIPLE_VENUES_INTO_A_TEAM = gql `mutation AddMultipleVenuesIntoTeam($venues: [league_team_venues_insert_input!]!) {
  insert_league_team_venues(
    objects: $venues,
    on_conflict: {
      constraint: league_team_venues_av_id_lt_id_key,
      update_columns: []  # do nothing if duplicate
    }
  ) {
    returning {
      ltv_id
      ltv_name
    }
  }
}`;

export const UPDATE_LEAGUE_TEAM_VENUE_AVID_BY_ID = gql `mutation UpdateLeagueTeamVenueAvIdById($ltv_id: uuid!, $av_id: uuid!) {
  update_league_team_venues_by_pk(pk_columns: {ltv_id: $ltv_id}, _set: {av_id: $av_id}) {
    ltv_updated_at
  }
}
`;

export const DELETE_VENUE_NAME_BY_ID = gql `mutation DeleteVenueNameById($ltv_id: uuid!) {
  delete_league_team_venues_by_pk(ltv_id: $ltv_id) {
    ltv_name
  }
}
`;

export const GET_ALL_VENUES_WITH_NAME_FILTER = gql `query GetAllVenuesWithNameFilter($name: String = "%%", $limit: Int, $offset: Int) {
  all_venues(order_by: {av_name: asc}, limit: $limit, offset: $offset, where: {av_name: {_ilike: $name}}) {
    av_id
    av_name
    av_street
    av_city
    av_country_code
    av_zipcode
    av_timezone
    av_state_code
    av_venue_ref_id
    av_latitude
    av_longitude
  }
}`;


export const GET_ALL_SUPER_USERS = gql `query GetAllActiveSuperUsers( $limit: Int=100, $offset: Int=0) {
  super_user(order_by: {su_email_id: asc}, limit: $limit, offset: $offset, where:{_and: {su_deleted_at: {_is_null: true}, su_is_active: {_eq: true}}}) {
    percentage
    su_created_at
    su_deleted_at
    su_email_id
    su_first_name
    su_id
    su_last_name
    su_updated_at
    u_id
  }
}`;


export const CREATE_SUPER_USER = gql `mutation CreateSuperUser($emailId: String!, $percentage: Float!) {
  promoteUserToSuperUser(promoteUserToSuperUserInput: {emailId: $emailId, percentage: $percentage}) {
    message
  }
}`;

export const DEACTIVATE_SUPER_USER= gql `mutation DeactivateSuperUser($emailId:String!){
  deactivateSuperUser(deactivateSuperUserInput: {emailId: $emailId}) {
    message
  } 
}
`

export const UPDATE_SUPER_USER_PERCENTAGE = gql `mutation UpdatePercentageForSuperUser($su_id: uuid!,$percentage: float8!){
   update_super_user_by_pk(pk_columns: {su_id: $su_id}, _set: {percentage: $percentage}) {
    percentage
    su_id
  }
}
`